import { createStyles, Group } from '@mantine/core';
import type { PrimitivePermissionType } from '@repo/api-codegen';
import type { UserRole } from '@repo/common/enums/UserRole';
import { Button } from '@repo/foundations';
import { buttonDropInAnimation } from '@repo/theme/primitives';
import { memo } from 'react';
import { useAuthUser, useCurrentUser } from '../../api';
import { PROMPT_SUGGESTIONS, type PromptSuggestion } from './constants';

const useStyles = createStyles((theme) => ({
	button: {
		borderRadius: theme.radius.lg,
		...buttonDropInAnimation,
	},
}));

export const AiPromptShotcuts = memo(
	({ onSelect }: { onSelect: (prompt: PromptSuggestion) => void }) => {
		const { classes } = useStyles();

		const { data: currentUser } = useCurrentUser();
		const permissions = currentUser?.permissions;
		const { user, workspace } = useAuthUser();

		if (!permissions) {
			return null;
		}

		const promptSuggestions = PROMPT_SUGGESTIONS.filter((prompt) => {
			if (prompt.requiredPermission) {
				if (workspace.migrated_permission_v2) {
					return permissions.includes(
						prompt.requiredPermission.v2Permission as PrimitivePermissionType
					);
				} else {
					return prompt.requiredPermission.v1AllowedRoles.includes(
						user.role as UserRole
					);
				}
			}
			return true;
		});

		return (
			<Group spacing="xs" align="center" position="center">
				{promptSuggestions.map((prompt, index) => (
					<Button
						key={prompt.prompt}
						leftIconName={prompt.icon}
						onClick={() => onSelect(prompt)}
						size="lg"
						className={classes.button}
						style={{
							animationDelay: `${index * 0.05}s`,
						}}
					>
						{prompt.label}
					</Button>
				))}
			</Group>
		);
	}
);
